export default __webpack_public_path__ + "static/media/stretching.6416b33c.jpeg";